import {Acceptor_Common} from "../../../../models/acceptor/acceptor_common";
import {AcceptorOutputFn, andAcceptorSingle} from "../../../../models/acceptor/IAcceptor";
import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {ISingleOutput} from "../../../../models/ISpec";
import {Utils} from "../../../../common/utils";
import {acceptSingle_common_Vout} from "./dcdc__common_acceptor";
import * as R from "ramda";

// tslint:disable-next-line:class-name
export class Acceptor_DcDc_LLC extends Acceptor_Common {

  constructor (ledDcDc: boolean= false) {super(ledDcDc); }

  protected acceptSingle_Vout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    /* check if single voltage output is defined and inside the bounds */

    const ret = (Utils.isValueEmpty(out.voltage) || (ic.vout_min <= out.voltage  &&  out.voltage <= ic.vout_max));

    // console.log(" Acceptor_DcDc_Buck acceptSingle_Buck_Vout - buck", ret, (Utils.isValueEmpty(out.voltage)));
    return ret;

  }
  protected acceptSingle_LLC_Iout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    /* check if single current output is defined and inside the bounds */
    const ret = (!Utils.isValueReal(out.current)) || ((R.propOr(0, 'iout_min',  a) <= out.current && out.current <= a.iout_max));
    // console.log("acceptSingle_common_Iout", ret);
    return ret;
  }

  protected acceptSingle_LLC_Pout: AcceptorOutputFn = (a: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    /* check if single current output is defined and inside the bounds */
    const i_min = R.propOr(0, 'iout_min',  a);
    const p_max = R.propOr(a.vout_max * a.iout_max, 'pout_max',  a);
    const p_min = R.propOr(a.vout_min * i_min, 'pout_min',  a);
    const ret = (!Utils.isValueReal(out.power)) || out.power >= p_min && out.power <= p_max;
    return ret;
  }


  protected singleOutputV(): AcceptorOutputFn {return andAcceptorSingle([acceptSingle_common_Vout, this.acceptSingle_Vout]); }
  protected singleOutputI(): AcceptorOutputFn {return this.acceptSingle_LLC_Iout; }
  protected singleOutputP(): AcceptorOutputFn {return this.acceptSingle_LLC_Pout; }

}
